import EditorExperience from "../../../InteractiveExperience";
import EventEmitter from "../../../utils/EventEmitter";

// import UI Components
import { UIPanel } from "../../ui.lib";
import { SidebarPinInfo } from "./Sidebar.PinInfo";
import { SidebarDirections } from "./Sidebar.Directions";
import { detectMobile } from "../../../../_utils/detectBrowser";

// import CloseIcon from "../../../../../assets/svgs/studio/interactiveMaps/cross_menu_dark.svg";

class Sidebar extends EventEmitter {
    constructor(props) {
        super(props);
        this.editor = new EditorExperience();
        this.parentEle = props.dom;

        this.selectedLocationPin = null;
        this.selectedPinMesh = null;
        this.isFLoatingBarOpen = true;

        // LOCATION_INFO, DIRECTIONS_SELECTOR, NAVIGATION
        this.activeType = "";
        this.contentProperties = {};
        this.objectProperties = {};

        this.activeDeviceMode = null; // "MOBILE" | "DESKTOP"

        this.editor.on(
            "toggleInteractiveSidebar",
            this.onToggleInteractiveSidebar
        );
        this.editor.on("updateSidebarMode", this.updateUIMode);
        this.editor.resources.on("ready", this.detectBrowserandAddEvents);

        this.editor.on("sceneSwitched", this.onExitNavigation);

        this.initUI();
    }

    initUI = () => {
        this.uiContainer = new UIPanel().addClass("wsInteractiveSidebarMobile");
        this.uiContainer.setDisplay("none");

        this.uiContainer.dom.style.height = "70%";

        // const uiCloseBtn = new UIImage(CloseIcon, "26px", "26px")
        //     .addClass("wsInteractiveSidebarMobile__closeBtn")
        //     .onClick(() => {
        //         this.onExitNavigation(false);
        //     });

        // this.uiContainer.addChild(uiCloseBtn);

        // components
        this.sidebarLocationPinInfo = new SidebarPinInfo(this.editor);
        this.uiContainer.addChild(this.sidebarLocationPinInfo.dom);
        this.objectProperties["LOCATION_INFO"] = this.sidebarLocationPinInfo;
        this.contentProperties["LOCATION_INFO"] =
            this.sidebarLocationPinInfo.dom;

        this.sidebarDirectionSelector = new SidebarDirections(this.editor);
        this.uiContainer.addChild(this.sidebarDirectionSelector.dom);
        this.objectProperties["DIRECTIONS_SELECTOR"] = this.sidebarDirectionSelector;
        this.contentProperties["DIRECTIONS_SELECTOR"] =
            this.sidebarDirectionSelector.dom;

        this.uiContainer.setDisplay("none");
        this.parentEle.append(this.uiContainer.dom);
    };

    updateUIType = () => {
        for (const key in this.contentProperties) {
            this.contentProperties[key].setDisplay(
                key === this.activeType ? "" : "none"
            );
        }
    };

    updateUIData = () => {
        if (this.activeType in this.objectProperties) {
            this.objectProperties[this.activeType].refreshUI(
                this.selectedLocationPin
            );
        }
    };

    updateUIMode = (mode) => {
        if (mode in this.contentProperties) {
            this.activeType = mode;
            this.updateUIType();
            this.updateUIData();
        }
    };

    onToggleInteractiveSidebar = (locationPin, mode) => {
        // console.log("onToggleInteractiveSidebar Mobile");
        this.activeType = mode;
        if (locationPin && this.activeType in this.contentProperties && this.activeDeviceMode === "MOBILE") {
            this.selectedLocationPin = locationPin;
            this.uiContainer.setDisplay("");
            this.updateUIType();
            this.updateUIData();
        } else {
            this.uiContainer.setDisplay("none");
            this.selectedLocationPin = null;
        }
    };

    updateVisibility = (bFlag) => {
        this.activeDeviceMode = bFlag ? "MOBILE" : "DESKTOP";
    };

    onExitNavigation = (bFlag) => {
        if (bFlag === false || !this.editor.navigationTracking) {
            this.editor.trigger("toggleInteractiveSidebar", [null]);
            this.editor.trigger("clearPathBetweenPins");
            this.editor.select(null);
        }
    }

    // detectBrowserandAddEvents = () => {
    //     const browser = detectMobile();
    //     if (browser) {
    //         const uiTouchHandler = new UIPanel().addClass(
    //             "wsInteractiveSidebarMobile__touchHandler"
    //         );
    //         this.uiContainer.addChild(uiTouchHandler);

    //         let startY = 0;
    //         let startHeight = 0;
    //         let dragging = false;

    //         uiTouchHandler.dom.addEventListener("touchstart", (e) => {
    //             dragging = true;
    //             startY = e.touches[0].clientY;
    //             startHeight = this.uiContainer.dom.offsetHeight;
    //             this.uiContainer.dom.style.transition = "none";
    //         });

    //         uiTouchHandler.dom.addEventListener("touchmove", (e) => {
    //             if (!dragging) return;
    //             const deltaY = e.touches[0].clientY - startY;
    //             let newHeight = startHeight - deltaY;
    //             // Clamp height between 60px and window height
    //             newHeight = Math.max(60, Math.min(window.innerHeight, newHeight));
    //             this.uiContainer.dom.style.height = `${newHeight}px`;
    //             this.uiContainer.dom.style.overflow = "auto";
    //         });

    //         uiTouchHandler.dom.addEventListener("touchend", () => {
    //             dragging = false;
    //             this.uiContainer.dom.style.transition = "";
    //         });
    //     }
    // };

    // detectBrowserandAddEvents = () => {
    //     const browser = detectMobile();
    //     if (browser) {
    //         // Remove uiTouchHandler, use this.uiContainer.dom for drag events
    //         const uiTouchHandler = new UIPanel().addClass(
    //             "wsInteractiveSidebarMobile__touchHandler"
    //         );
    //         this.uiContainer.addChild(uiTouchHandler);

    //         let startY = 0;
    //         let startHeight = 0;
    //         let dragging = false;

    //         this.uiContainer.dom.addEventListener("touchstart", (e) => {
    //             dragging = true;
    //             startY = e.touches[0].clientY;
    //             startHeight = this.uiContainer.dom.offsetHeight;
    //             this.uiContainer.dom.style.transition = "none";
    //         });

    //         let debounce;
    //         uiTouchHandlerDraggableArea.dom.addEventListener("touchmove", (e) => {
    //             if (!dragging) return;
    //             const deltaY = e.touches[0].clientY - startY;
    //             let newHeight = startHeight - deltaY;
    //             // Clamp height between 60px and window height
    //             newHeight = Math.max(60, Math.min(window.innerHeight, newHeight));
    //             this.uiContainer.dom.style.height = `${newHeight}px`;
    //             this.uiContainer.dom.style.overflow = "auto";

    //             if (debounce) clearTimeout(debounce);
    //             debounce = setTimeout(() => {
    //                 console.log("Resizing canvas to fit new height:", newHeight);
    //                 const canvas = this.editor.canvas;
    //                 if (canvas) {
    //                     const windowHeight = window.innerHeight;
    //                     const canvasHeight = windowHeight - newHeight;
    //                     // canvas.style.height = `${canvasHeight}px`;
    //                     this.editor.sizes.height = canvasHeight;
    //                     this.editor.sizes.trigger('resize');
    //                 }
    //             }, 1000);
    //         });

    //         this.uiContainer.dom.addEventListener("touchend", () => {
    //             dragging = false;
    //             this.uiContainer.dom.style.transition = "";
    //         });
    //     }
    // };

    detectBrowserandAddEvents = () => {
        const browser = detectMobile();
        // const os = detectOS();
        if (browser) {
            // Remove uiTouchHandler, use this.uiContainer.dom for drag events
            const uiTouchHandler = new UIPanel().addClass("wsInteractiveSidebarMobile__touchHandler");
            const uiTouchHandlerDraggableArea = new UIPanel().addClass("wsInteractiveSidebarMobile__touchHandlerDraggableArea");
            uiTouchHandler.addChild(uiTouchHandlerDraggableArea);
            uiTouchHandlerDraggableArea.dom.style.width = `${window.innerWidth}px`;
            uiTouchHandlerDraggableArea.dom.style.left = `-${(window.innerWidth - window.innerWidth / 2) - 30}px`;
            this.uiContainer.addChild(uiTouchHandler);

            let startY = 0;
            let startHeight = 0;
            let dragging = false;

            uiTouchHandlerDraggableArea.dom.addEventListener("touchstart", (e) => {
                dragging = true;
                startY = e.touches[0].clientY;
                startHeight = this.uiContainer.dom.offsetHeight;
                this.uiContainer.dom.style.transition = "none";
            });

            // let debounce;
            uiTouchHandlerDraggableArea.dom.addEventListener("touchmove", (e) => {
                if (!dragging) return;
                const deltaY = e.touches[0].clientY - startY;
                let newHeight = startHeight - deltaY;
                // Clamp height between 60px and window height
                newHeight = Math.max(60, Math.min(window.innerHeight, newHeight));
                this.uiContainer.dom.style.height = `${newHeight}px`;
                this.uiContainer.dom.style.overflow = "auto";

                // if (debounce) clearTimeout(debounce);
                // debounce = setTimeout(() => {
                //     const canvas = this.editor.canvas;
                //     if (canvas) {
                //         let margin = 0;
                //         let windowHeight = window.innerHeight;
                //         let canvasHeight = windowHeight - newHeight;
                //         if (os === "Android" || os === "Linux") margin += 50;
                //         if (os === "iOS" || os === "MacOS") margin += 110;
                //         canvasHeight += margin;
                //         canvas.style.height = `${canvasHeight}px`;
                //         this.editor.sizes.height = canvasHeight;
                //         this.editor.sizes.trigger('resize');
                //     }
                // }, 500);
            });

            uiTouchHandlerDraggableArea.dom.addEventListener("touchend", () => {
                dragging = false;
                this.uiContainer.dom.style.transition = "";
            });
        }
    };
}

export { Sidebar };
